import React, { Component } from "react";
import intl from "react-intl-universal";
import { Link } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import "./account.css";
import "react-table/react-table.css";
import NavSide from "./navSide";
import LicensePackages from "./Account/licensePackages";
import CloudProcessing from "./Account/cloudProcessing";
import Draggable from "react-draggable";
import ModalDialog from 'react-bootstrap/ModalDialog';
import ProtectionTypeDrawer from "./protectionTypeDrawer";

class DraggableModalDialog extends React.Component {
  render() {
      return <Draggable handle="#header"><ModalDialog {...this.props} /></Draggable>
  }
}

class Account extends Component {
  constructor(props) {
    super(props);

    this.state = {
      subscriptionsData: [],
      packagesData: [],
      packagesDataCustom: [],
      dictionaryOfSites: {},
      logsToDisplay: [],
      logsAccessGUID: "",
      isSubscriptionDataLoading: true,
      userData: [],
      isDataLoading: true,
      sort: {
        column: null,
        direction: "desc",
      },
      checkedItems: new Map(),
      autoRenewCheckboxDisabled: false,
      autoRenewCheckboxIsChecked: null,
      autoRenewCheckboxSubscriptionId: undefined,
      show: false,
      showLogs : false,
      ExpiresInDays: undefined,
      ExpiresInSubscription: undefined,
      hasSGStatusData: true,
      inTrial: undefined,
      cloudProcessingData: [],
      isCloudProcessingDataLoading: true,
      cloudProcessingPackages: [],
      iscloudProcessingPackagesLoading: true,
      tabsEnterKey: "packages",
      email: '',
      spinRefreshIcon: false,
      isDrawerLoading: false,
      openDrawer: false,
      protectionType: "floating",
      showSavedProtectionType: false,
      textAreaTexts: "",
      readOnlyTextArea: "",
      errorProtectionTypeMessage: "",
      numOfProtectionTypes: "0",
      activeProductId: "",
      activePackageId: "",
      isTrustedCustomer: false,
      toggleDrawerFromURL: false
    };

    this.handleShow = this.handleShow.bind(this);
    this.handleSubmitClose = this.handleSubmitClose.bind(this);
    this.handleClose = this.handleClose.bind(this);    

    this.getAccountPackagesData();
    this.getCloudProcessingStatus();
    
    // Comment out and add get packages for the new cloud packages. Maybe we'll want to add it again when we'll connect rebilly to the cloud.
    //this.getAccountSubscriptionsData();
  }

  componentDidMount() {
    var accountTabName = window.location.search.toLowerCase().match(
      /[?&]isCloudProcessing[=]([^&]+)/i
    );

    if (accountTabName !== null && accountTabName[1] === "true") {
      this.setState({tabsEnterKey: "cloudProcessing"});
    }
  }
  
  refreshData = () => {
    this.getAccountPackagesData();
    this.getCloudProcessingStatus();
  }

  GetEndpointsFromDB = () => {
    
    let url = process.env.REACT_APP_LAMBDA_API_MANAGER + "/getEndpointsFromDB";

    fetch(url, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "text/plain",
      },
      body: JSON.stringify({
        isLocal: (process.env.REACT_APP_IS_LOCAL == 'true'),
        searchText: '',
        sortString: '-workflowId',
        isSortDescending: false
      }),
    })
    .then((res) => { return res.json()})
    .then((result) => {
      if(result.ret.returnCode == "success"){
        // Assuming this code is inside a method of a React component
        var cloudProcessingPackages = this.state.cloudProcessingPackages;
        var endpointsData = JSON.parse(result.ret.data);

        cloudProcessingPackages.forEach(x => {
          x.products.endpoint_name = "";
        })
        // Iterate through each endpoint in endpointsData
        endpointsData.forEach(endpoint => {
          
          // Find the corresponding package in packagesWithEndpoints
          const packageIndex = cloudProcessingPackages.findIndex(x => x.products && x.products.endpoint_id === endpoint.endpoint_id);

          // If a package is found
          if (packageIndex !== -1) {
            // Update the products endpoint_name
            cloudProcessingPackages[packageIndex].products.endpoint_name = endpoint.endpoint_name;
          }
        });

        // Update the state with the modified cloudProcessingPackages
        this.setState({ cloudProcessingPackages: cloudProcessingPackages });
      }
    })
  }

  handleTabSelect = (key) => {
    if (key.toString().toLowerCase() == 'cloudprocessing') {
      window.history.pushState('', 'Skyline Cloud', '/store/account?isCloudProcessing=true');
    }
    else {
      window.history.pushState('', 'Skyline Cloud', '/store/account?isCloudProcessing=false');
    }
    this.setState({tabsEnterKey: key});
  }

  closeLogsDialog = () => {
    this.setState({ showLogs: false });
  }

  handleClose() {
    this.setState({ show: false });
  }

  handleSubmitClose() {
    this.handleOnChangeAutoRenew(
      this.state.autoRenewCheckboxSubscriptionId,
      !this.state.checkedItems.get(this.state.autoRenewCheckboxSubscriptionId)
    );
  }

  handleShow(isChecked, subscriptionId) {
    this.setState((prevState) => ({
      checkedItems: prevState.checkedItems.set(subscriptionId, !isChecked),
    }));
    this.setState({ autoRenewCheckboxSubscriptionId: subscriptionId });
    this.setState({ show: true });
  }  

  handleShowLogs = (value) => {
    this.setState({ showLogs: value });
  }

  handlelogsToDisplay = (value, AccessGUID) => {
    this.setState({ logsToDisplay: value, logsAccessGUID: AccessGUID });
  }

  handlelogsAccessGUID = (value) => {
    this.setState({handlelogsAccessGUID: value });
  }

  formatUserStatusData() {
    const userDataTemp = this.state.userData;
    if (userDataTemp.SiteExpireDate === "0001-01-01T00:00:00")
      this.setState((prevState) => ({
        userData: { ...prevState.userData, SiteExpireDate: "-" },
      }));
    if (userDataTemp.SiteStorageLimitDescp === "N/A")
      this.setState((prevState) => ({
        userData: { ...prevState.userData, SiteStorageLimitDescp: "-" },
      }));
    if (userDataTemp.SiteSessionsLimit == "-1")
      this.setState((prevState) => ({
        userData: { ...prevState.userData, SiteSessionsLimit: "-" },
      }));
  }

  getAccountPackagesData() {
    fetch(process.env.REACT_APP_API_URL + "GetUserPackages", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({fetchLogs: true})
    })
      .then((res) => {
        if (res.ok) {
          return res;
        } else {
          throw Error(`status ${res.status}`);
        }
      })
      .then((res) => res.json())
      .then((result) => {
        if (result.Result.toString().toLowerCase() === "success") {
          if (result.data != undefined && result.data.length > 0)
            this.setState({ email: result.data[0].email });
          else this.setState({email: "" });
          
          result.data.forEach((element) => {
            this.setState((prevState) => ({
              checkedItems: prevState.checkedItems.set(
                element.packages.Rebilly_SubscriptionId,
                element.packages.isAutoRenew
              ),
            }));
          });
          this.setState({ packagesData: result.data });
          this.setState({ isSubscriptionDataLoading: false });
          this.setState({ dictionaryOfSites: result.dictionaryOfSites });
    
          var data = result.data;
          var packagesDataCustom = this.state.packagesDataCustom;
          this.setState({cloudProcessingPackages: []});
          for(var i=0; i<data.length; i++){
            let found1 = Object.keys(packagesDataCustom).filter(key => data[i].packageId == key)[0]
            if(found1)
              packagesDataCustom[found1].push(data[i]);
            else
              packagesDataCustom[data[i].packageId] = [data[i]];

            if (data[i].products.BaseProduct === "PMCloud") {
              this.setState({cloudProcessingPackages: [...this.state.cloudProcessingPackages, data[i]]});
            }
          }
          //getting
          var packagesWithEndpoints = result.data.filter(x => x.products && x.products.endpoint_id !== null && x.products.endpoint_id !== "")
          if(packagesWithEndpoints.length > 0){
            this.GetEndpointsFromDB();
          }else{
            var cloudProcessingPackages = this.state.cloudProcessingPackages;
            cloudProcessingPackages.forEach(x => {
              x.products.endpoint_name = "";
            })
            this.setState({cloudProcessingPackages});
          }
          this.setState({ packagesDataCustom: packagesDataCustom, iscloudProcessingPackagesLoading: false, spinRefreshIcon: false });   
        } 
        else {
          this.setState({ isSubscriptionDataLoading: false, spinRefreshIcon: false });
        }
      })
      .catch((error) => {
        console.error(error);
        this.setState({ isSubscriptionDataLoading: false, spinRefreshIcon: false });
        if (error.message.includes("401"))
          this.props.userHasAuthenticated(false, undefined);
        else this.props.handleServerError(true);
      });
  }

  getAccountSubscriptionsData() {
    fetch(process.env.REACT_APP_API_URL + "getsubscriptions", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        if (res.ok) {
          return res;
        } else {
          throw Error(`status ${res.status}`);
        }
      })
      .then((res) => res.json())
      .then((result) => {
        if (result.Result.toString().toLowerCase() === "success") {
          result.Data.forEach((element) => {
            this.setState((prevState) => ({
              checkedItems: prevState.checkedItems.set(
                element.SubscriptionId,
                element.packages.isAutoRenew
              ),
            }));
            if (element.ExpirationInDays !== null) {
              if (element.InTrial) this.setState({ inTrial: true });
              this.setState({ ExpiresInDays: element.ExpirationInDays });
              this.setState({ ExpiresInSubscription: element.SubscriptionId });
            }
          });
          console.log(this.state.checkedItems);
          this.setState({ subscriptionsData: result.Data });
          this.setState({ isSubscriptionDataLoading: false });
        } else {
        }
      })
      .catch((error) => {
        console.error(error);
        if (error.message.includes("401"))
          this.props.userHasAuthenticated(false, undefined);
        else this.props.handleServerError(true);
      });
  }

  getCloudProcessingStatus = () => {
    fetch(process.env.REACT_APP_API_URL + "GetCloudProcessingStatus", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({})
    })
      .then((res) => {
        if (res.ok) {
          return res;
        } else {
          throw Error(`status ${res.status}`);
        }
      })
      .then((res) => res.json())
      .then((result) => {
        if (result.Result.toString().toLowerCase() === "success") {
          this.setState({ cloudProcessingData: result.data });
          this.setState({ isCloudProcessingDataLoading: false });
        } 
        else {
          this.setState({ isCloudProcessingDataLoading: false });
        }
      })
      .catch((error) => {
        console.error(error);
        this.setState({ isCloudProcessingDataLoading: false });
        if (error.message.includes("401"))
          this.props.userHasAuthenticated(false, undefined);
        else this.props.handleServerError(true);
      });
  }

  handleOnChangeAutoRenew = (SubscriptionId, value) => {
    this.setState({ autoRenewCheckboxDisabled: true });
    fetch(process.env.REACT_APP_API_URL + "changeAutoRenew", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        subscriptionId: SubscriptionId,
        newValue: value,
      }),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.Result.toString().toLowerCase() === "success") {
          this.setState({ autoRenewCheckboxDisabled: false });
          this.setState((prevState) => ({
            checkedItems: prevState.checkedItems.set(SubscriptionId, value),
          }));
          this.setState({ show: false });
        } else {
        }
      })
      .catch((error) => {
        console.error(error);
        this.setState({ show: false });
        this.props.handleServerError(true);
      });
  };

  handleUpdateProtectionTypeState = (productId, value) => {
    let items = [...this.state.packagesData];
    let itemIndex = items.findIndex(x => x.Id === productId);
    let item = {...items[itemIndex]};

    item.protectionTypeCodes = value;
    items[itemIndex] = item;
    this.setState({ packagesData: items });
  }

  onSort = (column) => (e) => {
    const direction = this.state.sort.column
      ? this.state.sort.direction === "asc"
        ? "desc"
        : "asc"
      : "desc";
    const sortedData = this.state.subscriptionsData.sort((a, b) => {
      if (column === "SubscriptionId") {
        const subA = a.SubscriptionId.toUpperCase(); // ignore upper and lowercase
        const subB = b.SubscriptionId.toUpperCase(); // ignore upper and lowercase
        if (subA < subB) {
          return -1;
        }
        if (subA > subB) {
          return 1;
        }

        // names must be equal
        return 0;
      } else if (column === "CreatedTime") {
        return new Date(b.CreatedTime) - new Date(a.CreatedTime);
      } else {
        return;
        //return a.contractValue - b.contractValue;
      }
    });

    if (direction === "desc") {
      sortedData.reverse();
    }

    this.setState({
      subscriptionsData: sortedData,
      sort: { column, direction },
    });
  };

  setArrow = (column) => {
    let className = "tableSorter";
    if (this.state.sort.column === column) {
      className += this.state.sort.direction === "asc" ? " asc" : " desc";
    }

    return className;
  };

  bytesToSize = (bytes) => {
    var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes == 0) return '0 GB';
    var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
  }

  fetchSiteRemainingStorage = (siteId) => {

    for (var key in this.state.dictionaryOfSites) {
      if(siteId == key){
        return this.bytesToSize(this.state.dictionaryOfSites[key].SiteStorageRemaining);
      }
    }
    return 0;
  }

  fetchSiteUsedStorage = (siteId) => {
    for (var key in this.state.dictionaryOfSites) {
      if(siteId == key){
        return this.bytesToSize(this.state.dictionaryOfSites[key].SiteStorageLimit - this.state.dictionaryOfSites[key].SiteStorageRemaining);
      }
    }
    return 0;
  }

  IsJsonString = (jsonString) => {
      try {
          JSON.parse(jsonString);
      } catch (e) {
          return false;
      }
      return true;
  }

  createHeadersAndDataForCsv = () => {
    var rows = [];
    //create headers
    var tmpHeaders = {
      AccessGUID: "Access Token",
      Time: "Date",
      Total: "Total",
      GPLeft: "Available",
      Gp: "Used"
    }
    rows.push(tmpHeaders);
    var arr = this.state.logsToDisplay;
    for(var i=0; i<arr.length; i++){
      
      var tmpObjData = {
        AccessGUID: this.state.logsAccessGUID,
        Time: this.convert_server_dt_format(arr[i].Time),
        Total: this.IsJsonString(arr[i].Message) ?
            (parseFloat(JSON.parse(arr[i].Message).GP) && parseFloat(JSON.parse(arr[i].Message).GPLeft)) 
              ? (parseFloat(JSON.parse(arr[i].Message).GP) + parseFloat(JSON.parse(arr[i].Message).GPLeft))
              : parseFloat(JSON.parse(arr[i].Message).GPLeft).toFixed(2)
          : "",
        GPLeft: this.IsJsonString(arr[i].Message) ?  parseFloat(JSON.parse(arr[i].Message).GPLeft).toFixed(2) : "",
        Gp: this.IsJsonString(arr[i].Message) ? parseFloat(JSON.parse(arr[i].Message).GP) ? parseFloat(JSON.parse(arr[i].Message).GP).toFixed(2) : "-" : ""
      }
      rows.push(tmpObjData);
    }
    return rows;
  }

  exportToCsv = (filename) => {
    var rows = this.createHeadersAndDataForCsv();
    var processRow = function (row) {
      var finalVal = '';
      var j = 0;
      Object.keys(row).forEach(key => {
        var innerValue = row[key] === null ? '' : row[key].toString();
          var result = innerValue.replace(/"/g, '""');
          if (result.search(/("|,|\n)/g) >= 0)
              result = '"' + result + '"';
          if (j > 0)
               finalVal += ',';
          j++;
          finalVal += result;
      });
      return finalVal + '\n';
    };

    var csvFile = '';
    for (var i = 0; i < rows.length; i++) {
        csvFile += processRow(rows[i]);
    }

    var blob = new Blob([csvFile], { type: 'text/csv;charset=utf-8;' });
    if (navigator.msSaveBlob) { // IE 10+
        navigator.msSaveBlob(blob, filename);
    } else {
        var link = document.createElement("a");
        if (link.download !== undefined) { // feature detection
            // Browsers that support HTML5 download attribute
            var url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", filename);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }
  }

  convert_server_dt_format = (dtStr) => {
    
    var defaultDt = "01/01/0001 00:00:00z";

    if(!dtStr || typeof dtStr != "string")
      return defaultDt;

    if(dtStr.slice(-1).toLowerCase() != 'Z')
      dtStr += 'Z';
    var dt = new Date(dtStr.replace(/[:](?=\d{6}\s*$)/, ".").trim());
    return new Date(dt).toDateString() + " " + `${dt.getHours().toString().padStart(2, '0')}:${dt.getMinutes().toString().padStart(2, '0')}`;
  }

  addingParamToPass = (packageId, BaseProductName) => {

    var buildParamString = "";
    switch(BaseProductName) {
      case 'CloudHosting':
        buildParamString = 'gettingStartedUploads?displayLogin=1&packageId=' + packageId + "#publishDataSection";
        break;
      case 'PMGigaPixel':
        buildParamString = 'gettingStartedProducts?displayLogin=1&packageId=' + packageId + "#" + "InstallPhotoMeshSection";
        break;
      case 'PhotoMesh':
        buildParamString = 'gettingStartedProducts?displayLogin=1&packageId=' + packageId + "#" + "InstallPhotoMeshSection";
        break;
      case 'SkylineGlobeServer':
        buildParamString = 'gettingStartedProducts?displayLogin=1&packageId=' + packageId + "#" + "InstallSkylineGlobeServerSection";
        break;
      case 'TerraBuilder':
        buildParamString = 'gettingStartedProducts?displayLogin=1&packageId=' + packageId + "#" + "InstallTerraBuilderSection";
        break;
      case 'TerraExplorerPlus':
        buildParamString = 'gettingStartedProducts?displayLogin=1&packageId=' + packageId + "#" + "InstallTerraExplorerPlusSection";
        break;
      case 'TerraExplorerPro':
        buildParamString = 'gettingStartedProducts?displayLogin=1&packageId=' + packageId + "#" + "InstallTerraExplorerProSection";
        break;
      default:
        break;
    }
    return buildParamString;
  }

  calcTotal = (row) => {
    if (row.products.BaseProduct == "CloudHosting") {
      var totalUsers = 0;
      for (var key in this.state.dictionaryOfSites) {
        if (row.cloudSiteId == key) {
          totalUsers = this.state.dictionaryOfSites[key].SiteSessionsLimit;
        }
      }
      totalUsers += " Users / "
      return totalUsers + this.bytesToSize(row.amountValue)
    }

    if (row.products.BaseProduct == "PMGigaPixel" || row.products.BaseProduct == "PMCloud") {
      return parseFloat((row.GPInitValue || 0).toFixed(2)) + " GP ";
    }

    if (row.products.BaseProduct == "SkylineGlobeServer") {
      return row.ConcurrentUsers + " Users"
    } else {
      return row.noOfLics + " Lics"
    }
  }

  calcAvailable = (row) => {
    if(row.products.BaseProduct == "CloudHosting"){
      var totalUsersLeft = 0;
      for (var key in this.state.dictionaryOfSites) {
        if(row.cloudSiteId == key){
          totalUsersLeft = this.state.dictionaryOfSites[key].SiteSessionsRemaining;
        }
      }
      totalUsersLeft += " Users / "
      return totalUsersLeft + this.fetchSiteRemainingStorage(row.cloudSiteId);
    }

    if(row.products.BaseProduct == "PMGigaPixel" || row.products.BaseProduct == "PMCloud"){
      return parseFloat((row.amountValue || 0).toFixed(2)) + " GP ";
    }
    
    if(row.products.BaseProduct == "SkylineGlobeServer"){
      return " -- "
    } else {
      return (row.noOfLics - row.ammountOfUsersThatUsingThisLic) + " Lics"
    }
  }

  calcUsed = (row) => {
    if(row.products.BaseProduct == "CloudHosting"){
      var totalUsersUsed = 0;
      for (var key in this.state.dictionaryOfSites) {
        if(row.cloudSiteId == key){
          totalUsersUsed = (this.state.dictionaryOfSites[key].SiteSessionsLimit - this.state.dictionaryOfSites[key].SiteSessionsRemaining);
        }
      }
      totalUsersUsed += " Users / "
      return totalUsersUsed + this.fetchSiteUsedStorage(row.cloudSiteId)
    }

    if(row.products.BaseProduct == "PMGigaPixel" || row.products.BaseProduct == "PMCloud"){
      return (parseFloat((row.GPInitValue || 0).toFixed(2)) - parseFloat((row.amountValue || 0).toFixed(2))).toFixed(2) + " GP ";
    }

    if(row.products.BaseProduct == "SkylineGlobeServer"){
      return " -- "
    } else {
      return (row.ammountOfUsersThatUsingThisLic) + " Lics"
    }
  }

  changeSpinRefreshIcon = () =>{
    this.setState({spinRefreshIcon: true});
  }

  toggleDrawer = (open, productId, protectionType, numOfLics, fromURL) => {
    this.setState({ openDrawer: open });
    this.setState({ errorProtectionTypeMessage: "" });
    this.setState({ isDrawerLoading: true });
    this.setState({ toggleDrawerFromURL: !!fromURL });

    if (open) {
      this.setState({ protectionType: protectionType });

      fetch(process.env.REACT_APP_API_URL + "GetProtectionTypeCodesByProductId", {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          productId: productId
        }),
      })
        .then((res) => res.json())
        .then((result) => {
          if (result.success) {
            if (result.data) {
              this.handleUpdateProtectionTypeState(productId, result.data);
              let item = this.state.packagesData[this.state.packagesData.findIndex(x => x.Id == productId)];
              if (item != undefined && item.protectionTypeCodes.length > 0) {
                item.protectionTypeCodes = item.protectionTypeCodes.filter(x => x !== "");
                this.setState({ readOnlyTextArea: item.protectionTypeCodes.join('\n') });
                this.setState({ numOfProtectionTypes: item.protectionTypeCodes.length + '/' + numOfLics });
                this.setState({ activeProductId: productId });
                this.setState({ activePackageId: item.packageId });
                this.setState({ isTrustedCustomer: item.packages.TrustedCustomer });
              }
            }
          } else {
            let item = this.state.packagesData[this.state.packagesData.findIndex(x => x.Id == productId)];
            if (item != undefined && item.protectionTypeCodes.length > 0) {
              item.protectionTypeCodes = item.protectionTypeCodes.filter(x => x !== "");
              this.setState({ readOnlyTextArea: item.protectionTypeCodes.join('\n') });
              this.setState({ numOfProtectionTypes: item.protectionTypeCodes.length + '/' + numOfLics });
              this.setState({ activeProductId: productId });
              this.setState({ activePackageId: item.packageId });
              this.setState({ isTrustedCustomer: item.packages.TrustedCustomer });
            }
          }
          this.setState({ isDrawerLoading: false });
          return true;
        })
        .catch((error) => {
          console.error(error);
          this.setState({ show: false });
          this.setState({ isDrawerLoading: false });
          this.props.handleServerError(true);
          return true;
        });
    }
    else{
      this.setState({ protectionType: "floating" });

      this.setState({ showSavedProtectionType: false });
      this.setState({ textAreaTexts: "" });
      this.setState({ readOnlyTextArea: "" });
      this.setState({ numOfProtectionTypes: "-"});
      this.setState({ activeProductId: "" });
      this.setState({ activePackageId: "" });
    } 

    // console.log(this.state.packagesData[this.state.packagesData.findIndex(x => x.Id == productId)]);
    // console.log(this.state.readOnlyTextArea);

  }

  handleChangeMachineCodeInput = (event) => {
    this.setState({ textAreaTexts: event.target.value });
  }

  handleClearClick = () => {
    this.setState({ textAreaTexts: ""});
    this.setState({ errorProtectionTypeMessage: "" });
  }

  handleSavedProtectionTypeCodes = (res) => {
    this.setState({ textAreaTexts: "" });
    this.setState({ readOnlyTextArea: res.protectionTypeCodes.join('\n') });
    this.setState({ numOfProtectionTypes: res.protectionTypeCodes.length + '/' + res.noOfLics });

    this.handleUpdateProtectionTypeState(this.state.activeProductId, res.protectionTypeCodes);

    this.setState(prevState => ({
      packagesDataCustom: prevState.packagesDataCustom.map(innerArray =>
        innerArray.map(item =>
          item.Id === this.state.activeProductId ? { ...item, protectionTypeCodes: res.protectionTypeCodes } : item
        )
      )
    }));
    

    // Show Protection type saved
    this.setState({ showSavedProtectionType: true });
    setTimeout(() => {
      this.setState({ showSavedProtectionType: false });
    }, 3000); // Display for 3 seconds
  }

  handleErrorSavedProtectionTypeCodes = (errorMessage) => {
    this.setState({ errorProtectionTypeMessage: errorMessage });
  }

  render() {
    return (
      <div className="container accountContainer accountMainContainer">
        <NavSide email={this.state.email} />
        {this.state.ExpiresInDays ? (
          <div id="divWarning">
            <button
              id="x"
              onClick={(event) => this.setState({ ExpiresInDays: undefined })}
            >
              X
            </button>
            {intl.get("Account_Subscription_Expires_In_Days", {
              subscriptionId: this.state.ExpiresInSubscription,
              days: this.state.ExpiresInDays,
            })}
          </div>
        ) : null} 
        {this.state.tabsEnterKey === "packages" ?
          <LicensePackages
            isSubscriptionDataLoading={this.state.isSubscriptionDataLoading}
            isDataLoading={this.state.isDataLoading}
            packagesDataCustom={this.state.packagesDataCustom}
            dictionaryOfSites={this.state.dictionaryOfSites}
            handleShowLogs={this.handleShowLogs}
            handlelogsToDisplay={this.handlelogsToDisplay}
            handlelogsAccessGUID={this.handlelogsAccessGUID}
            addingParamToPass={this.addingParamToPass}
            calcTotal={this.calcTotal}
            calcAvailable={this.calcAvailable}
            calcUsed={this.calcUsed}
            toggleDrawer={this.toggleDrawer}
            props={this.state}
            sgsUrl={this.props.sgsUrl}
          /> :
          <CloudProcessing
            iscloudProcessingPackagesLoading={this.state.iscloudProcessingPackagesLoading}
            cloudProcessingPackages={this.state.cloudProcessingPackages}
            isCloudProcessingDataLoading={this.state.isCloudProcessingDataLoading}
            cloudProcessingData={this.state.cloudProcessingData}
            calcAvailable={this.calcAvailable}
            calcUsed={this.calcUsed}
            props={this.props}
            refreshData={this.refreshData}
            changeSpinRefreshIcon={this.changeSpinRefreshIcon}
            spinRefreshIcon={this.state.spinRefreshIcon}
          />}
        
        <Modal
          show={this.state.show}
          onHide={this.handleClose}
          size="sm"
          animation={false}
          aria-labelledby="contained-modal-title-vcenter"
          centered="true"
        >
          <Modal.Header closeButton>
            <Modal.Title
              className="modalTitle"
              id="contained-modal-title-vcenter"
            >
              {this.state.checkedItems.get(
                this.state.autoRenewCheckboxSubscriptionId
              )
                ? intl.get("Account_Turning_Off_Auto_Renew_Title")
                : intl.get("Account_Turning_On_Auto_Renew_Title")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>
              {this.state.checkedItems.get(
                this.state.autoRenewCheckboxSubscriptionId
              )
                ? intl.get("Account_Turning_Off_Auto_Renew_Description")
                : intl.get("Account_Turning_On_Auto_Renew_Description")}
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleClose}>
              Close
            </Button>
            <Button
              className="ModalButtonClass"
              variant="primary"
              onClick={this.handleSubmitClose}
            >
              {this.state.checkedItems.get(
                this.state.autoRenewCheckboxSubscriptionId
              )
                ? intl.get("Account_Turn_Off_Button")
                : intl.get("Account_Turn_On_Button")}
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal 
          show={this.state.showLogs}           
          onHide={this.closeLogsDialog}
          animation={false}
          aria-labelledby="example-modal-sizes-title-lg"
          centered="true"
          id="logsPopupModal"
          size='lg'
          dialogAs={DraggableModalDialog}
        >
          <Modal.Header id="header">
            <button type="button" class="close"><span aria-hidden="true" onClick={this.closeLogsDialog}>×</span><span class="sr-only">Close</span></button>
            <Modal.Title className="modalTitle" id="example-modal-sizes-title-lg">Logs</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="modalBodyHeader">
              <span>GigaPixel Transaction</span>
              <span className="floatRight"><Link onClick={(e) => { this.exportToCsv("reports.csv"); e.preventDefault();}} to="">Download as CSV</Link></span>
            </div>
            <table>
              <thead>
                <tr>
                  <th>Access Token</th>
                  <th>Date</th>
                  <th>Total</th>
                  <th>Available</th>
                  <th>Used</th>
                </tr>
              </thead>
              <tbody>
              {
                this.state.logsToDisplay.map((row, j) => {
                  return (
                    <tr key={j}>
                      <td className="row1OfPopupLogs">{this.state.logsAccessGUID}</td>
                      <td className="row2OfPopupLogs">
                        {
                          this.convert_server_dt_format(row.Time)
                        }
                      </td>
                      <td className="row3OfPopupLogs">
                        {this.IsJsonString(row.Message) ?
                          (parseFloat(JSON.parse(row.Message).GP) && parseFloat(JSON.parse(row.Message).GPLeft)) 
                            ? (parseFloat(JSON.parse(row.Message).GP) + parseFloat(JSON.parse(row.Message).GPLeft))
                            : parseFloat(JSON.parse(row.Message).GPLeft).toFixed(2)
                         : ""}
                      </td>
                      <td className="row4OfPopupLogs">{this.IsJsonString(row.Message) ?  parseFloat(JSON.parse(row.Message).GPLeft).toFixed(2) : ""}</td>
                      <td className="row5OfPopupLogs">{this.IsJsonString(row.Message) ? parseFloat(JSON.parse(row.Message).GP) ? parseFloat(JSON.parse(row.Message).GP).toFixed(2) : "-" : ""}</td>
                    </tr>
                  );
                })
              }
              </tbody>
            </table>
          </Modal.Body>
          <Modal.Footer>
            <Button className="ModalButtonClass" variant="primary" onClick={this.closeLogsDialog}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        <ProtectionTypeDrawer
        openDrawer={this.state.openDrawer}
        toggleDrawer={this.toggleDrawer}
        protectionType={this.state.protectionType}
        readOnlyTextArea={this.state.readOnlyTextArea}
        numOfProtectionTypes={this.state.numOfProtectionTypes}
        showSavedProtectionType={this.state.showSavedProtectionType}
        textAreaTexts={this.state.textAreaTexts}
        handleChangeMachineCodeInput={this.handleChangeMachineCodeInput}
        handleClearClick={this.handleClearClick}
        errorProtectionTypeMessage={this.state.errorProtectionTypeMessage}
        protectionTypeState={this.state.packagesData !== undefined && this.state.packagesData.length > 0 && this.state.activeProductId != "" ? this.state.packagesData[this.state.packagesData.findIndex(x => x.Id === this.state.activeProductId)].protectionTypeCodes.filter(str => str !== "") : 0}
        productId={this.state.activeProductId}
        packageId={this.state.activePackageId}
        handleErrorSavedProtectionTypeCodes={this.handleErrorSavedProtectionTypeCodes}
        handleSavedProtectionTypeCodes={this.handleSavedProtectionTypeCodes}
        isDrawerLoading={this.state.isDrawerLoading}
        isTrustedCustomer={this.state.isTrustedCustomer}
        toggleDrawerFromURL={this.state.toggleDrawerFromURL}
        >
        </ProtectionTypeDrawer>
      </div>
    );
  }
}

export default Account;
